import { useTranslation } from 'react-i18next'
import { FC, useEffect, useState } from 'react'
import { selectedDataTake } from '../../../utils/selectedDataTake/selectedDataTake'
import { ISelectData } from '../select/model'
import SingleSelect from '../select/SingleSelect'
import { ISelectDataProps } from '../../../global.model'
import { useGetAllExpertsQuery } from '../../../store/api/expert/expert'

const SelectCourse: FC<ISelectDataProps> = ({ selected, setSelected, isDisabled }): JSX.Element => {
  const { t: tSideBar } = useTranslation('sideBar')
  const [page, setPage] = useState<number>(1)
  const { data: courses, refetch: lessonRefetch } = useGetAllExpertsQuery({
    page,
    pageSize: 30
  })
  const [expertData, setExpertData] = useState<ISelectData[]>([])

  useEffect(() => {
    setExpertData([])
    if (page !== 1) {
      setPage(1)
    } else {
      lessonRefetch()
    }
  }, [])

  useEffect(() => {
    if (page === 1) {
      lessonRefetch()
    }
  }, [page])

  useEffect(() => {
    selectedDataTake(courses?.data, setExpertData)
  }, [courses])

  return (
    <div className='w-100'>
      <label className='text-dark mt-5' htmlFor='exampleInputname'>
        {tSideBar('experts')}
      </label>
      <SingleSelect
        data={expertData}
        editData={selected}
        setData={setSelected}
        setPageByScroll={setPage}
        dataCount={courses?.count}
        isDisabled={isDisabled}
      />
    </div>
  )
}

export default SelectCourse
